var resizeTimer = null;

//js计算法则精度校正
var floatObj = function () {

    /*
    * 判断obj是否为一个整数
    */
    function isInteger(obj) {
        return Math.floor(obj) === obj
    }

    /*
    * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
    * @param floatNum {number} 小数
    * @return {object}
    * {times:100, num: 314}
    */
    function toInteger(floatNum) {
        var ret = { times: 1, num: 0 };
        if (isInteger(floatNum)) {
            ret.num = floatNum;
            return ret
        }
        var strfi = floatNum + '';
        var dotPos = strfi.indexOf('.');
        var len = strfi.substr(dotPos + 1).length;
        var times = Math.pow(10, len);
        var intNum = parseInt(floatNum * times + 0.5, 10);
        ret.times = times;
        ret.num = intNum;
        return ret
    }

    /*
    * 核心方法，实现加减乘除运算，确保不丢失精度
    * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
    *
    * @param a {number} 运算数1
    * @param b {number} 运算数2
    * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
    *
    */
    function operation(a, b, op) {
        var o1 = toInteger(a);
        var o2 = toInteger(b);
        var n1 = o1.num;
        var n2 = o2.num;
        var t1 = o1.times;
        var t2 = o2.times;
        var max = t1 > t2 ? t1 : t2;
        var result = null;
        switch (op) {
            case 'add':
                if (t1 === t2) { // 两个小数位数相同
                    result = n1 + n2
                } else if (t1 > t2) { // o1 小数位 大于 o2
                    result = n1 + n2 * (t1 / t2)
                } else { // o1 小数位 小于 o2
                    result = n1 * (t2 / t1) + n2
                }
                return result / max;
            case 'subtract':
                if (t1 === t2) {
                    result = n1 - n2
                } else if (t1 > t2) {
                    result = n1 - n2 * (t1 / t2)
                } else {
                    result = n1 * (t2 / t1) - n2
                }
                return result / max;
            case 'multiply':
                result = (n1 * n2) / (t1 * t2);
                return result;
            case 'divide':
                result = (n1 / n2) * (t2 / t1);
                return result
        }
    }

    // 加减乘除的四个接口
    function add(a, b) {
        return operation(a, b, 'add')
    }

    function subtract(a, b) {
        return operation(a, b, 'subtract')
    }

    function multiply(a, b) {
        return operation(a, b, 'multiply')
    }

    function divide(a, b) {
        return operation(a, b, 'divide')
    }

    // exports
    return {
        add: add,
        subtract: subtract,
        multiply: multiply,
        divide: divide
    }
}();

var Utils = {
    addlocalStorage: function (key, value) {
        if (typeof (Storage) != "undefined") {
            localStorage.setItem(key, value);
        }
    },
    getlocalStorage: function (key) {
        if (typeof (Storage) != "undefined") {
            return localStorage.getItem(key);
        }
    },
    IsNullOrEmpty: function (obj) {
        if (obj == null || typeof (obj) == "undefined" || obj == "") {
            return true;
        }
        return false;
    },
    // 设置横竖屏,true为竖屏,反之,addDom:是否加进维护队列
    setWinDirect: function (isVertical, dom, addDom) {
        if (addDom)
            winResizeDomList.push({
                vert: isVertical,
                dom: dom
            });
        var body = document.getElementsByTagName('body')[0];
        var html = document.getElementsByTagName('html')[0];
        var width = html.clientWidth;
        var height = html.clientHeight;
        var max = width > height ? width : height;
        var min = width > height ? height : width;
        var tag = Utils.IsNullOrEmpty(dom) ? body : dom;
        if (!isVertical) {
            tag.style.width = max + "px";
            tag.style.height = min + "px";
        } else {
            tag.style.width = min + "px";
            tag.style.height = max + "px";
        }
    },
    
    GetUrlParams: function (val) {
        var url = window.parent.location.href;
        if (url.indexOf("?") === -1) return null;
        var after = window.parent.location.search.substr(1) || window.parent.location.hash.split("?")[1];
        if (after) {
            try {
                var reg = new RegExp("(^|&)" + val + "=([^&]*)(&|$)");
                return decodeURIComponent(after.match(reg)[2]);
            } catch (error) {
                return null;
            }
        }
    },
    //⁰ ¹ ² ³ ⁴ ⁵ ⁶ ⁷ ⁸ ⁹ ⁺ ⁻ ⁼ ⁽ ⁾ ⁿ º ˙
    formartMathPow: function (val, pow) {
        var num = Math.abs(pow);
        switch (num) {
            case 0:
                num = "⁰";
                break;
            case 1:
                num = "¹";
                break;
            case 2:
                num = "²";
                break;
            case 3:
                num = "³";
                break;
            case 4:
                num = "⁴";
                break;
            case 5:
                num = "⁵";
                break;
            case 6:
                num = "⁶";
                break;
            case 7:
                num = "⁷";
                break;
            case 8:
                num = "⁸";
                break;
            case 9:
                num = "⁹";
                break;
            default:
                break;
        }

        var fh = pow > 0 ? "" : "⁻";
        return val + " × 10" + fh + num;
    },
    /***************************************
        * 生成从minNum到maxNum的随机数。
        * 如果指定decimalNum个数，则生成指定小数位数的随机数
        * 如果不指定任何参数，则生成0-1之间的随机数。
        *
        * @minNum：[数据类型是Integer]生成的随机数的最小值（minNum和maxNum可以调换位置）
        * @maxNum：[数据类型是Integer]生成的随机数的最大值
        * @decimalNum：[数据类型是Integer]如果生成的是带有小数的随机数，则指定随机数的小数点后的位数
        *
        ****************************************/
    randomNum: function (maxNum, minNum, decimalNum) {
        var max = 0, min = 0;
        minNum <= maxNum ? (min = minNum, max = maxNum) : (min = maxNum, max = minNum);
        switch (arguments.length) {
            case 1:
                return Math.floor(Math.random() * (max + 1));
                break;
            case 2:
                return Math.floor(Math.random() * (max - min + 1) + min);
                break;
            case 3:
                return (Math.random() * (max - min) + min).toFixed(decimalNum);
                break;
            default:
                return Math.random();
                break;
        }
    },
    floatObj: floatObj

};

export default {
    install: function (Vue) {
        Vue.prototype.Utils = Utils,
        Date.prototype.dateFormat = function (fmt) { //author: meizz   
            var o = {
                "M+": this.getMonth() + 1,                 //月份   
                "d+": this.getDate(),                    //日   
                "h+": this.getHours(),                   //小时   
                "m+": this.getMinutes(),                 //分   
                "s+": this.getSeconds(),                 //秒   
                "q+": Math.floor((this.getMonth() + 3) / 3), //季度   
                "S": this.getMilliseconds()             //毫秒   
            };
            if (/(y+)/.test(fmt))
                fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
            for (var k in o)
                if (new RegExp("(" + k + ")").test(fmt))
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            return fmt;
        }
    }
};


